import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const authHeader = () => {
  const token = localStorage.getItem('cap_token');
  return token ? { Authorization: `Bearer ${token}` } : {};
};

const h = () => ({ headers: { ...authHeader(), 'Content-Type': 'application/json' } });
const hAuth = () => ({ headers: authHeader() });

export const communityApi = {
  // ── Theses ──
  listTheses: async (tag) => {
    const params = tag ? `?tag=${encodeURIComponent(tag)}` : '';
    const { data } = await axios.get(`${API}/community/theses${params}`, hAuth());
    return data;
  },
  createThesis: async (thesis) => {
    const { data } = await axios.post(`${API}/community/theses`, thesis, h());
    return data;
  },
  deleteThesis: async (id) => { await axios.delete(`${API}/community/theses/${id}`, hAuth()); },
  toggleLike: async (id) => { const { data } = await axios.post(`${API}/community/theses/${id}/like`, {}, hAuth()); return data; },
  rateThesis: async (id, score) => { const { data } = await axios.post(`${API}/community/theses/${id}/rate`, { score }, h()); return data; },

  // ── Comments (theses) ──
  getComments: async (thesisId) => { const { data } = await axios.get(`${API}/community/theses/${thesisId}/comments`, hAuth()); return data; },
  addComment: async (thesisId, content, parentId) => {
    const body = { content };
    if (parentId) body.parent_id = parentId;
    const { data } = await axios.post(`${API}/community/theses/${thesisId}/comments`, body, h());
    return data;
  },
  deleteComment: async (id) => { await axios.delete(`${API}/community/comments/${id}`, hAuth()); },
  toggleCommentLike: async (id) => { const { data } = await axios.post(`${API}/community/comments/${id}/like`, {}, hAuth()); return data; },

  // ── Q&A ──
  listQuestions: async (sort = 'recent') => { const { data } = await axios.get(`${API}/community/questions?sort=${sort}`, hAuth()); return data; },
  createQuestion: async (q) => { const { data } = await axios.post(`${API}/community/questions`, q, h()); return data; },
  deleteQuestion: async (id) => { await axios.delete(`${API}/community/questions/${id}`, hAuth()); },
  getAnswers: async (qId) => { const { data } = await axios.get(`${API}/community/questions/${qId}/answers`, hAuth()); return data; },
  addAnswer: async (qId, content) => { const { data } = await axios.post(`${API}/community/questions/${qId}/answers`, { content }, h()); return data; },
  toggleAnswerLike: async (id) => { const { data } = await axios.post(`${API}/community/answers/${id}/like`, {}, hAuth()); return data; },

  // ── Performances / Results ──
  listPerformances: async () => { const { data } = await axios.get(`${API}/community/performances`, hAuth()); return data; },
  publishPerformance: async (p) => { const { data } = await axios.post(`${API}/community/performances`, p, h()); return data; },
  deletePerformance: async (id) => { await axios.delete(`${API}/community/performances/${id}`, hAuth()); },

  // ── Admin ──
  getPendingVerifications: async () => { const { data } = await axios.get(`${API}/community/admin/pending-verifications`, hAuth()); return data; },
  verifyPerformance: async (id, action) => { const { data } = await axios.post(`${API}/community/admin/verify/${id}?action=${action}`, {}, hAuth()); return data; },

  // ── Feed ──
  getFeed: async (filter = 'all') => { const { data } = await axios.get(`${API}/community/feed?filter_type=${filter}`, hAuth()); return data; },

  // ── Sharing ──
  getSharing: async () => { const { data } = await axios.get(`${API}/community/sharing`, hAuth()); return data; },
  updateSharing: async (settings) => { const { data } = await axios.put(`${API}/community/sharing`, settings, h()); return data; },
  requestFounderAnalysis: async () => { const { data } = await axios.post(`${API}/community/request-founder-analysis`, {}, hAuth()); return data; },
  searchMembers: async (q) => { const { data } = await axios.get(`${API}/community/search-members?q=${encodeURIComponent(q)}`, hAuth()); return data; },

  // ── XP ──
  getXp: async () => { const { data } = await axios.get(`${API}/community/xp`, hAuth()); return data; },

  // ── Notifications ──
  getNotifications: async () => { const { data } = await axios.get(`${API}/community/notifications`, hAuth()); return data; },
  getUnreadCount: async () => { const { data } = await axios.get(`${API}/community/notifications/unread-count`, hAuth()); return data; },
  markNotificationsRead: async () => { const { data } = await axios.post(`${API}/community/notifications/mark-read`, {}, hAuth()); return data; },

  // ── Leaderboard ──
  getLeaderboard: async (ranking = 'xp', period = 'alltime') => { const { data } = await axios.get(`${API}/community/leaderboard?ranking=${ranking}&period=${period}`, hAuth()); return data; },

  // ── Badges ──
  getBadges: async () => { const { data } = await axios.get(`${API}/community/badges`, hAuth()); return data; },

  // ── Track Analysis ──
  trackAnalysis: async () => { const { data } = await axios.post(`${API}/community/track-analysis`, {}, hAuth()); return data; },

  // ── Public Portfolios ──
  getPublicPortfolios: async () => { const { data } = await axios.get(`${API}/community/public-portfolios`, hAuth()); return data; },

  // ── Trends ──
  getTrends: async () => { const { data } = await axios.get(`${API}/community/trends`, hAuth()); return data; },
};
